export default {
    config: {
        defaultWidth: 200
    },
    default: {
        label: 'Condition'
    },
    unique: [],
    lang: {
        name: 'Condition',
        category: ['User', 'Collection'],
        description: 'Condition note set on the collection item.',
        views: ['list', 'sheet'],
    },
    filters: ['collection.condition']
}
